(() => {
  if (window.matildeRelatedScrollReady) return;
  window.matildeRelatedScrollReady = true;
  function init(root) {
    root.querySelectorAll('[data-related-products]').forEach(section => {
      if (section.dataset.scrollReady) return;
      section.dataset.scrollReady = 'true';
      const track = section.querySelector('.related-products-scroll__track');
      const buttons = [...section.querySelectorAll('[data-related-direction]')];
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.relatedDirection) < 0 ? track.scrollLeft <= 1 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.relatedDirection) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement));
})();
